import { createAction, createAsyncAction, ActionType } from 'typesafe-actions';
import { UnifiedCompareState, ProductErrorState, CompareActions } from './types';
import { Product } from 'common/components/product-card/types';
import { ValidationRules } from './reducers/validation-error';

export const SEND_PRODUCTS_COMPARE_ACTION = createAction('ui/SEND_PRODUCTS_COMPARE_ACTION')<{
  action: CompareActions;
  productId: string;
  familyId: string;
  groupId: string;
  groupName?: string;
  withData?: boolean;
  productIds?: string[];
}>();

export type SendProductsCompareAction = ActionType<typeof SEND_PRODUCTS_COMPARE_ACTION>;

export const RESET_PRODUCTS_COMPARE_ACTION = createAction('ui/RESET_PRODUCTS_COMPARE_ACTION')();

export type ResetProductsCompareAction = ActionType<typeof RESET_PRODUCTS_COMPARE_ACTION>;

export const RETRY_LAST_COMPARE_ACTION = createAction('ui/RETRY_LAST_COMPARE_ACTION')();

export type RetryLastCompareAction = ActionType<typeof RETRY_LAST_COMPARE_ACTION>;

export const PRODUCTS_COMPARE_SET_ACTIVE_GROUP_ID = createAction('productsCompare/SET_ACTIVE_GROUP_ID')<
  string | null
>();

export type ProductsCompareSetActiveGroupIdActions = ActionType<typeof PRODUCTS_COMPARE_SET_ACTIVE_GROUP_ID>;

export const PRODUCTS_COMPARE_MANAGE = createAsyncAction(
  'productsCompare/MANAGE/request',
  'productsCompare/MANAGE/success',
  'productsCompare/MANAGE/failure',
  'productsCompare/MANAGE/cancel',
)<
  { groupId: string; action: CompareActions; productId?: string },
  UnifiedCompareState,
  ProductErrorState,
  void
>();

export const PRODUCTS_COMPARE_LOAD_DATA = createAsyncAction(
  'productsCompare/LOAD_DATA/request',
  'productsCompare/LOAD_DATA/success',
  'productsCompare/LOAD_DATA/failure',
  'productsCompare/LOAD_DATA/cancel',
)<
  { groupId: string; productIds: string[] },
  { groupId: string; productsData: Record<string, Product> },
  ProductErrorState,
  void
>();

export const MANAGE_PRODUCT_IN_COMPARE_LIST = createAction(
  'productsCompare/MANAGE_PRODUCT_IN_COMPARE_LIST',
)<{
  action: CompareActions;
  productId: string;
  groupName?: string;
  familyId?: string;
  withData?: boolean;
  productIds?: string[];
}>();

export const SET_VALIDATION_ERROR = createAction(
  'productsCompare/SET_VALIDATION_ERROR',
)<ValidationRules | null>();

export const RESET_VALIDATION = createAction('productsCompare/RESET_VALIDATION')();

export type CompareValidationActions =
  | ActionType<typeof SET_VALIDATION_ERROR>
  | ActionType<typeof RESET_VALIDATION>;

export type ManageProductInCompareListAction = ActionType<typeof MANAGE_PRODUCT_IN_COMPARE_LIST>;

export type ProductsCompareManageActions =
  | ActionType<typeof PRODUCTS_COMPARE_MANAGE.request>
  | ActionType<typeof PRODUCTS_COMPARE_MANAGE.success>
  | ActionType<typeof PRODUCTS_COMPARE_MANAGE.failure>
  | ActionType<typeof PRODUCTS_COMPARE_MANAGE.cancel>;

export type ProductsCompareLoadDataActions =
  | ActionType<typeof PRODUCTS_COMPARE_LOAD_DATA.request>
  | ActionType<typeof PRODUCTS_COMPARE_LOAD_DATA.success>
  | ActionType<typeof PRODUCTS_COMPARE_LOAD_DATA.failure>
  | ActionType<typeof PRODUCTS_COMPARE_LOAD_DATA.cancel>;

export type AllProductsCompareActions =
  | ProductsCompareManageActions
  | ProductsCompareLoadDataActions
  | SendProductsCompareAction
  | RetryLastCompareAction
  | ManageProductInCompareListAction
  | ProductsCompareSetActiveGroupIdActions
  | ResetProductsCompareAction;
